import { Worker, WorkerInvoice } from "@/types";
import { useEffect, useState } from "react";

import { FindPersonModal } from "#/organisms";
import { WorkerInvoices } from "#/pages";
import { useApi } from "@/api";
import { useModal } from "@/hooks";

const WorkerInvoicesView = () => {
  const { order, worker } = useApi();

  const { showModal, onCloseModal, onOpenModal } = useModal();
  const [loadingWorkers, setLoadingWorkers] = useState(false);
  const [called, setCalled] = useState(false);
  const [workers, setWorkers] = useState<Worker[]>([]);
  const [invoices, setInvoices] = useState<WorkerInvoice[]>();

  const getWorkerInvoicesList = async (id?: string) => {
    setLoadingWorkers(true);
    const inv = await worker.getWorkerInvoiceList(id || 'all');
    setInvoices(inv);
    setLoadingWorkers(false);
  }

  useEffect(() => {
    if (!called) {
      setCalled(true)
      getWorkerInvoicesList();
    }
  }, [called]);

  // useEffect(() => {
  //   getWorkerInvoicesList();
  // }, []);

  const handleApprove = async (ids: string[]) => {
    worker.setInvoiceApproved(ids);
    await getWorkerInvoicesList();
  }

  const handleDelete = async (id: string) => {
    await worker.deleteInvoice(id);
    await getWorkerInvoicesList();
  }

  const handleMarkAsPaid = async (ids: string[]) => {
    await worker.setInvoicePaid(ids);
    await getWorkerInvoicesList();
  }

  const handleFindPerson = async (search: string) => {
    const w = await order.findWorker(search);
    setWorkers(w);
  };

  const handleSelect = (id: string) => {
    getWorkerInvoicesList(id);
    onCloseModal();
  };

  return (
    <>
      <WorkerInvoices
        loading={loadingWorkers}
        workerInvoices={invoices || []}
        onApprove={handleApprove}
        onDelete={handleDelete}
        onMarkAsPaid={handleMarkAsPaid}
        onNewInvoice={onOpenModal}
      />
      {showModal && (
        <FindPersonModal
            onFindPerson={handleFindPerson}
            onSelectPerson={handleSelect}
            persons={workers.map((item) => ({
              email: item.email,
              id: item.id,
              name: item.name,
            }))
            }
            onClose={onCloseModal}
          />
      )}
    </>
  );
}

export default WorkerInvoicesView;